import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({ baseURL: API });

// v9: entrar, crear cuenta y recuperar la contraseña nunca llevan la sesión guardada. Antes, quien había probado
// la demo no podía registrarse ni recuperar su contraseña (la sesión demo es de solo lectura).
const PUBLIC_AUTH = ["/auth/login", "/auth/register", "/auth/forgot-password", "/auth/reset-password"];
const isPublicAuth = (url = "") => PUBLIC_AUTH.some((p) => url.startsWith(p));

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("ca_token");
  if (token && !isPublicAuth(config.url)) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

// v9: sesión caducada o no válida dentro del panel → a la pantalla de entrada con un aviso claro,
// en vez de errores sueltos. Si caduca un «Ver como», se vuelve a la sesión de admin.
let redirecting = false;
api.interceptors.response.use(
  (r) => r,
  (err) => {
    const status = err?.response?.status;
    const url = err?.config?.url || "";
    const hadToken = !!err?.config?.headers?.Authorization;
    if (status === 401 && hadToken && !isPublicAuth(url) && !redirecting) {
      const inApp = window.location.pathname.startsWith("/app");
      const adminTok = localStorage.getItem("ca_admin_token");
      if (localStorage.getItem("ca_impersonation") && adminTok) {
        localStorage.setItem("ca_token", adminTok);
        localStorage.removeItem("ca_admin_token");
        localStorage.removeItem("ca_impersonation");
        redirecting = true;
        window.location.href = "/app/admin";
      } else {
        localStorage.removeItem("ca_token");
        if (inApp) {
          redirecting = true;
          window.location.href = "/acceso?sesion=caducada";
        }
      }
    }
    return Promise.reject(err);
  }
);

// P-08: si dos componentes piden el mismo GET a la vez (p. ej. /business-brain al entrar al panel),
// comparten la misma petición en vuelo. No cachea respuestas: en cuanto termina, la siguiente vuelve a pedir.
const inflight = new Map();
const rawGet = api.get.bind(api);
api.get = (url, config) => {
  const key = url + (config && config.params ? JSON.stringify(config.params) : "");
  if (inflight.has(key)) return inflight.get(key);
  const p = rawGet(url, config).finally(() => inflight.delete(key));
  inflight.set(key, p);
  return p;
};

export function apiError(err, fallback = "Algo ha fallado. Inténtalo de nuevo.") {
  const detail = err?.response?.data?.detail;
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((d) => d.msg).filter(Boolean).join(" ") || fallback;
  return fallback;
}

export default api;
